<template>
  <SvgIcon
    name="icone_favoritos"
    :fill="favorito.fill"
    view-box="0 0 50 48"
    height="22"
    width="auto"
    @mouseover="handleHoverFavoritos"
    @mouseleave="handleHoverFavoritos"
    @click="toggle"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SvgIcon from '@/components/ui/SvgIcon';

export default {
  name: 'CheckboxFavoritos',

  props: {
    materiaId: Number,
    favorita: Boolean,
  },

  components: {
    SvgIcon,
  },

  computed: {
    ...mapGetters({
      favorito: 'favoritos/favorito',
    }),
  },

  mounted() {
    if (this.favorita) {
      this.favorite();
    } else {
      this.rmFavorite();
    }
  },

  methods: {
    ...mapActions({
      handleHoverFavoritos: 'favoritos/handleHoverFavoritos',
      handleToggleFavoritos: 'favoritos/handleToggleFavoritos',
      favorite: 'favoritos/favorite',
      rmFavorite: 'favoritos/rmFavorite',
    }),

    toggle() {
      this.handleToggleFavoritos(this.materiaId);
    },
  },
};
</script>

<style scoped lang="scss"></style>
